<form #formRef class="search-form" [formGroup]="searchForm" (ngSubmit)="onFormSubmit()" autocomplete="off"
    [ngClass]="{'-mode-filter': mode !== 'hero', '-mode-hero': mode === 'hero', '-collapsed': !open && enableClose}">
    <div class="search-form__inner" [ngClass]="{'-actions-visible': submitVisible || clearVisible}">

        <shared-icon (click)="handleOpenClick()" icon="search" class="search-form__icon"
            [ngClass]="{'-clickable': enableClose && !open}"></shared-icon>

        <div class="search-form__placeholder" [ngClass]="{'-hidden': !isPlaceholderVisible}" *ngIf="placeholder && open"
            [@fadeOut]="animateOut ? 'out' : 'in'" (click)="onPlaceholderClick()">{{placeholder}}</div>

        <ng-container *ngIf="!showAutocomplete">
            <input type="text" class="search-form__input" [ngClass]="{'-hidden': isPlaceholderVisible}" *ngIf="open"
                formControlName="searchInput" #input (blur)="inputOnBlur()" (focus)="inputOnFocus()">
        </ng-container>

        <ng-container *ngIf="showAutocomplete">
            <shared-places-suggestion [enabled]="isTyping" [refElem]="formRef"
                class="search-form__input-with-suggestions" [ngClass]="{'-hidden': isPlaceholderVisible}"
                [searchTerm]="searchTerm" (onSelected)="handleAddressSelected($event)">

                <input (blur)="inputOnBlur()" (focus)="handleAutocompleteFocus()" type="text" class="search-form__input"
                    [ngClass]="{'-hidden': isPlaceholderVisible}" *ngIf="open" formControlName="searchInput" #input>

            </shared-places-suggestion>
        </ng-container>

        <div class="search-form__actions" [hidden]="!clearVisible && !submitVisible" *ngIf="open">
            <shared-circle-btn [disabled]="disabled" class="search-form__submit"
                [isActive]="searchForm.value.searchInput" [disabled]="isFormDisabled" role="button" type="submit"
                icon="next" *ngIf="submitVisible && !clearVisible && enableSubmit" feel="brand-accent" size="md">
            </shared-circle-btn>

            <shared-circle-btn [disabled]="disabled" *ngIf="isClearVisible" class="search-form__clear" size="xs"
                icon="close" feel="dark" (click)="clearForm()">
            </shared-circle-btn>

            <shared-icon-btn *ngIf="enableClose" class="search-form__close" feel="plain" size="xs" icon="close"
                (click)="handleCloseClick()">
            </shared-icon-btn>
        </div>

    </div>
</form>
